import { HttpResponse } from "@angular/common/http";

export interface Upload {
    progress: number;
    state: 'INITIAL' | 'PENDING' | 'IN_PROGRESS' | 'DONE' | 'SAVING';
    response?: HttpResponse<any>;
};
